import { useEffect, useState } from "react";
import { Button, Img, Text, Radio } from "components";
import { useTranslation } from "react-i18next";
import SavedAddressesList from "./SavedAddressesList";
import PickUpPointsList from "./PickUpPointsList";
import SendAsAGift from "./SendAsAGift";
import styled from "styled-components";
import {
  updateOrderData,
  getOrderData,
} from "../../../../redux/reducers/orderData";
import { useDispatch, useSelector } from "react-redux";
import { AddEditAddress } from "popups/AddEditAddress";
import { changeTrigger } from "redux/reducers/trigger";

const Tab = styled.div`
  ${({ isSelected }) =>
    isSelected &&
    ` 
border-color: #BD0043 !important;
`}
`;
// const Panal = styled.div`
//   ${({ isSelected }) =>
//     isSelected &&
//     `
// display: block;
// `}
// `;

const DeliveryMode = ({
  addressList,
  zoneList,
  occasionOptions,
  isEventSent,
  setIsEventSent,
  sendCheckoutGaEvent,
}) => {
  const orderData = useSelector(getOrderData);
  const [AddAddressPopup, setAddAddressPopup] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // const handleTabClick = (index) => {
  //   if (!isEventSent?.beginCheckout) {
  //     setIsEventSent((prev) => ({ ...prev, beginCheckout: true }));
  //     sendCheckoutGaEvent("begin_checkout");
  //   }
  //   dispatch(
  //     updateOrderData({
  //       ...orderData,
  //       delivery_mode: "",
  //       deliveryModeTabIndex: index,
  //       delivery_type: "",
  //       deliveryDateTimeActiveTab: 0,
  //     })
  //   );
  // };
  const handleTabClick = (index) => {
    if (!isEventSent?.beginCheckout) {
      setIsEventSent((prev) => ({ ...prev, beginCheckout: true }));
      sendCheckoutGaEvent("begin_checkout");
    }
    let orderDataDelivery = {
      ...orderData,
      delivery_mode: "",
      deliveryModeTabIndex: index,
      delivery_type: "",
      deliveryDateTimeActiveTab: 0,
    };
    delete orderDataDelivery?.timeSloat;
    dispatch(
      updateOrderData({
        ...orderData,
        delivery_mode: "",
        deliveryModeTabIndex: index,
        delivery_type: "",
        deliveryDateTimeActiveTab: 0,
        // FIX #1: addAddressPopup ko explicitly false karo jab tab switch ho,
        // taaki stale redux state se popup na khule
        addAddressPopup: false,
      })
    );
  };

  // FIX #1: Pehle yeh useEffect orderData?.addAddressPopup watch karta tha,
  // lekin iska problem yeh tha ki addAddressPopup: true redux mein persist rehta tha
  // aur baad mein kisi bhi ...orderData spread se popup dobara khul jaata tha.
  // Ab hum local setAddAddressPopup directly SavedAddressesList ko prop ke roop mein
  // pass karte hain (cart version ki tarah), redux ke zariye nahi.
  //
  // useEffect(() => {
  //   if (orderData?.addAddressPopup) {
  //     setAddAddressPopup(true);
  //   }
  // }, [orderData?.addAddressPopup]);

  useEffect(() => {
    if (AddAddressPopup === "getAddressList") {
      setAddAddressPopup(false);
      dispatch(changeTrigger("loadAddressList"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AddAddressPopup]);

  useEffect(() => {
    setActiveTab(
      orderData?.deliveryModeTabIndex ? orderData?.deliveryModeTabIndex : 0
    );
  }, [orderData?.deliveryModeTabIndex]);

  return (
    <>
      <div className="relative flex flex-col w-full">

        {/* ── Completed delivery mode summary ── */}
        {orderData?.pageStep > 2 ? (
          <div className="flex flex-col gap-4 items-center justify-start w-full mb-2">
            <div className="flex flex-row xs:flex-col md:gap-5 items-center xs:items-start justify-start w-full">
              <div className="flex flex-col gap-1 items-start justify-start flex-1">
                <Text
                  className="
                    font-medium text-black-900 font-['Unbounded']
                    text-[24px] sm:text-[20px] sm:leading-[28px] sm:font-normal
                  "
                >
                  {t("deliveryMode")}:{" "}
                  {orderData?.delivery_mode === "buying_for_love" ? t("buyingForALovedOne") : ""}
                  {orderData?.delivery_mode === "pickup_point" ? t("PickUpPoint") : ""}
                  {orderData?.delivery_mode === "home_office" ? t("Home") : ""}
                </Text>

                {orderData?.delivery_mode === "buying_for_love" ? (
                  <>
                    <div className="flex gap-1 flex-row items-center">
                      <Text className="text-black-900 text-sm font-nunitoregular">
                        {orderData?.buying_for_love?.recipient_name}
                      </Text>
                    </div>
                    <div className="flex gap-1 flex-row items-center">
                      <Text className="text-black-900 text-sm font-['Inter']">
                        {orderData?.buying_for_love?.country_code}{" "}
                        {orderData?.buying_for_love?.mobile_no} |{" "}
                        {orderData?.buying_for_love?.email}
                      </Text>
                    </div>
                  </>
                ) : (
                  <div className="flex gap-1 flex-row items-center">
                    <Text className="text-black-900 text-sm font-['Inter']">
                      {orderData?.delivery_mode === "home_office" ? orderData?.home_office?.address : null}
                      {orderData?.delivery_mode === "pickup_point" ? orderData?.home_office?.address : null}
                    </Text>
                  </div>
                )}
              </div>
              <Button
                className="w-auto mx-auto px-3 py-1.5 text-sm sm:mx-0"
                size="sm"
                variant="OutlineBlack"
                onClick={() => {
                  dispatch(
                    updateOrderData({
                      ...orderData,
                      pageStep: 2,
                      delivery_mode: "",
                      delivery_type: "",
                      // FIX #1: Change button click par bhi addAddressPopup reset karo
                      addAddressPopup: false,
                    })
                  );
                }}
              >
                {t("change")}
              </Button>
            </div>
          </div>
        ) : null}

        {/* ── pageStep === 2: show unified tab UI ── */}
        {orderData?.pageStep === 2 ? (
          <div className="flex flex-col w-full mt-0.5 mb-2">

            {/* 
              UNIFIED TAB STRUCTURE — matches image design:
              "Delivery Information" heading + pill tabs 
              (Delivery Addresses | Pickup Points | Send Gift)
              
              SavedAddressesList now owns the tab bar and renders
              the appropriate content panel inside itself.
              
              PickUpPointsList & SendAsAGift are passed as slot props
              so SavedAddressesList can render them inside the tab panel
              without needing a separate outer conditional.

              FIX #1: setAddAddressPopup ab prop ke roop mein SavedAddressesList
              ko pass kiya ja raha hai, taaki handleEditAddress directly local state
              update kare — redux ke zariye nahi (jo stale state aur popup bug ka
              kaaran tha). Yeh cart version (doc 6) ke pattern ke jaisa hai.
            */}
            <SavedAddressesList
              addressList={addressList}
              isEventSent={isEventSent}
              setIsEventSent={setIsEventSent}
              sendCheckoutGaEvent={sendCheckoutGaEvent}
              // FIX #1: Direct popup control — cart version ki tarah
              setAddAddressPopup={setAddAddressPopup}
              AddAddressPopup={AddAddressPopup}
              onTabChange={(tab) => {
                // Map internal tab id → deliveryModeTabIndex
                const indexMap = { home: 1, pickup: 2, gift: 3 };
                handleTabClick(indexMap[tab] ?? 1);
              }}
              /* Slot: Pickup Points panel */
              pickupContent={
                <PickUpPointsList
                  zoneList={zoneList}
                  isEventSent={isEventSent}
                  setIsEventSent={setIsEventSent}
                  sendCheckoutGaEvent={sendCheckoutGaEvent}
                />
              }
              /* Slot: Send Gift panel */
              giftContent={
                <SendAsAGift
                  occasionOptions={occasionOptions}
                  isEventSent={isEventSent}
                  setIsEventSent={setIsEventSent}
                  sendCheckoutGaEvent={sendCheckoutGaEvent}
                />
              }
            />

            {/* OLD separate tab card UI — commented, logic now inside SavedAddressesList */}
            {/* 
            <div className="flex flex-row md:flex-col flex-wrap w-full gap-x-3 md:gap-y-3 mt-[22px] mb-[18px]">
              <Tab className="..." isSelected={activeTab === 1} onClick={() => handleTabClick(1)}>
                ...Home/Office tab...
              </Tab>
              <Tab className="..." isSelected={activeTab === 2} onClick={() => handleTabClick(2)}>
                ...Pickup tab...
              </Tab>
              <Tab className="..." isSelected={activeTab === 3} onClick={() => handleTabClick(3)}>
                ...Gift tab...
              </Tab>
              {activeTab === 1 ? <SavedAddressesList ... /> : null}
              {activeTab === 2 ? <PickUpPointsList ... /> : null}
              {activeTab === 3 ? <SendAsAGift ... /> : null}
            </div>
            */}

            {AddAddressPopup ? (
              <AddEditAddress
                setAddAddressPopup={setAddAddressPopup}
                orderData={orderData}
                pageName={"cart"}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default DeliveryMode;
